import React, { useEffect, useState } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

import CloseIcon from "@mui/icons-material/Close";
import InfoIcon from "@mui/icons-material/Info";

import { IconButton } from "@mui/material";
import { useSubscribeToSectionMutation } from "./Service";
import { SuccessModal } from "./SuccessModal";
import { FailModal } from "./FailModal";
import { useParams } from "react-router-dom";
import { useQueryClient } from "@tanstack/react-query";
import { useSelector } from "react-redux";
export function PurchaseConfirmationModal({
  open,
  setOpen,
  sectionName,
  secionCost,
  sectionId,
  courseId,
}) {
  const token = useSelector((state) => state.Auth.userInfo.token);
  const [openSuccess, setOpenSuccess] = useState(false);
  const [openFail, setOpenFail] = useState(false);
  // const [onSuccess, setOnSuccess] = useState({});
  const { idCourse } = useParams();

  const handleClose = () => {
    setOpen(false);
  };

  const queryClient = useQueryClient();

  const {
    mutate: mutateSubscribe,
    data: dataSubscribe,
    isSuccess: isSuccessSubscribe,

  } = useSubscribeToSectionMutation();

  const handleSubmit = () => {
    mutateSubscribe({
      section_id: +sectionId,
      course_id: +courseId,
    });
  };

  useEffect(() => {
    if (isSuccessSubscribe && dataSubscribe?.status == 200) {
      setOpenSuccess(true);
      handleClose();
      let apiInvalidateQuerie = setTimeout(() => {
        queryClient.invalidateQueries({
          queryKey: [`GetSectionsCourse${idCourse}`],
        });
      }, 1000);

      return () => {
        clearTimeout(apiInvalidateQuerie);
      };
    } else if (isSuccessSubscribe && dataSubscribe?.response?.status == 401) {
      setOpenFail(true);
      handleClose();
    }
  }, [isSuccessSubscribe]);

  return (
    <div>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          <IconButton onClick={handleClose}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent sx={{ p: "40px" }}>
          <DialogContentText
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              gap: "10px",
            }}
            id="alert-dialog-description"
          >
            <InfoIcon color="info" />
            <span>
              هل أنت متأكد من شراء {sectionName}؟ سوف يتم خصم {secionCost} نقطة
              من رصيدك
            </span>
          </DialogContentText>
        </DialogContent>
        <DialogActions
          sx={{
            display: "flex",
            justifyContent: "space-around",
            gap: "40px",
            width: "80%",
            mx: "auto",
          }}
        >
          <Button variant="contained" onClick={handleSubmit} fullWidth>
            شراء
          </Button>

          <Button fullWidth color="error" variant="text" onClick={handleClose}>
            الغاء
          </Button>
        </DialogActions>
      </Dialog>

      <SuccessModal
        openSuccess={openSuccess}
        setOpenSuccess={setOpenSuccess}
        message={dataSubscribe?.data?.message}
      />

      <FailModal
        openSuccess={openFail}
        setOpenSuccess={setOpenFail}
        message={dataSubscribe?.response?.data?.message}
      />
    </div>
  );
}
